import { SUBSCRIPTION_MESSAGE_TYPE } from 'util/config/constant';
import {
  NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED,
  NEW_MESSAGE_FOR_NOTIFICATION_ADDED
} from './action';
import * as subscription from './subscription';
import { generateMessageId } from './util/generate-message-id';

/**
 * Subscribe message from cleaning report topic
 * @param {*} payload
 * @returns
 */
export function subscribeCleaningReportAdded(payload) {
  const { userId } = payload;

  return (dispatch, _, { client } = {}) => {
    const observableInstance = client.subscribe({
      query: subscription.subscribeCleaningReportAdded,
      variables: {
        userId
      }
    });

    observableInstance.subscribe((response) => {
      const data = response?.data?.subscribeCleaningReportAdded || {};
      const messageId = generateMessageId(
        SUBSCRIPTION_MESSAGE_TYPE.CLEANING_REPORT
      );

      dispatch({
        type: NEW_MESSAGE_FOR_CLEANING_REPORT_ADDED,
        payload: {
          messageId,
          data
        }
      });
    });
  };
}

/**
 * Subscribe message from notification topic
 * @param {*} payload
 * @returns
 */
export function subscribeNotificationAdded(payload) {
  const { userId } = payload;

  return (dispatch, _, { client } = {}) => {
    const observableInstance = client.subscribe({
      query: subscription.subscribeNotificationAdded,
      variables: {
        userId
      }
    });

    observableInstance.subscribe((response) => {
      const data = response?.data?.subscribeNotificationAdded || {};
      const messageId = generateMessageId(
        SUBSCRIPTION_MESSAGE_TYPE.NOTIFICATION
      );

      dispatch({
        type: NEW_MESSAGE_FOR_NOTIFICATION_ADDED,
        payload: {
          messageId,
          data
        }
      });
    });
  };
}
